<template>
  <index-content :breadcrumb-items="breadcrumbItems">
    <template #options>
      <div class="n-button-box">
        <nb-sort v-model="sortable" />
        <nb-add @on-click="openModal" />
      </div>
    </template>
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped text-center n-table">
        <thead>
          <th class="col-weight-3">{{ $t('label.id') }}</th>
          <th class="col-weight-3">{{ $t('label.company') }}</th>
          <th class="col-weight-10">{{ $t('label.iosStoreId') }}</th>
          <th class="col-weight-10">{{ $t('label.andStoreId') }}</th>
          <th class="col-weight-4">{{ $t('label.title') }}</th>
          <th class="col-weight-4">{{ $t('label.label') }}</th>
          <th class="col-weight-4">{{ $t('label.recommend') }}</th>
          <th v-table-action class="action-edit">{{ $t('label.action') }}</th>
        </thead>
        <n-draggable v-model="records" :disabled="!sortable" @on-change="onDropped">
          <tr v-for="row in records" :key="row.id">
            <td>{{ row.id }}</td>
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td>{{ row.iosStoreId }}</td>
            <td>{{ row.andStoreId }}</td>
            <td>{{ row.title }}</td>
            <td>{{ row.label }}</td>
            <td><n-icon-boolean :value="row.recommend" /></td>
            <td class="n-button-box">
              <nb-modal @on-click="openModal(row)"></nb-modal>
              <nb-confirm text="remove" @on-ok="doRemove(row)"></nb-confirm>
            </td>
          </tr>
        </n-draggable>
      </table>
    </div>
  </index-content>
</template>

<script>
import BaseCompanyView from './view';
import ModalCompanyLpProduct from './ModalCompanyLpProduct.vue';
import { fetch, remove, sort } from '@/api/company/company-lp-product';
import DndMixin from "@/mixins/dnd-mixin.vue";

export default BaseCompanyView.extend({
  name: 'CompanyLpProduct',
  mixins: [DndMixin],

  data() {
    return {
      preload: true,
    };
  },

  mounted() {
    this.lpId = +this.$route.params.lpId;
    this.breadcrumbItems = [this.lpId, this.$t(`label.products`)];
  },

  methods: {
    doLoad() {
      let lpId = this.lpId;
      return fetch({ lpId });
    },

    doRemove(o) {
      return remove(o);
    },

    openModal(model = { lpId: this.lpId }) {
      this.createModal(ModalCompanyLpProduct, { model, props: { subName: 'product' }, on: this });
    },

    parse(r) {
      this.records = r;
    },

    doDrop(list) {
      return sort(this.lpId, { lppIds: list.map(r => r.id).join(',') });
    },
  },
});
</script>

<style lang="scss" scoped>
.n-table {
  th.rw-action {
    width: 9rem;
  }
}
</style>